import { urlForImage } from "@/js/sanity/image";
export default {
  name: "PostSection3",
  methods: {
    urlForImage: urlForImage
  },
  props: {
    sectionData: {
      type: Object,
      required: true
    }
  }
};